export default "__VITE_ASSET__CgDbCoom__"